import { render, staticRenderFns } from "./ProjectNotesCard.vue?vue&type=template&id=8bafdc88&"
import script from "./ProjectNotesCard.vue?vue&type=script&lang=js&"
export * from "./ProjectNotesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports